// extracted by css-extract-rspack-plugin
export default {"contentContainer":"src-components-HourlyForecast-HourlyForecast-module__contentContainer-pAYVuY","title":"src-components-HourlyForecast-HourlyForecast-module__title-BhsE34"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"contentContainer\":\"src-components-HourlyForecast-HourlyForecast-module__contentContainer-pAYVuY\",\"title\":\"src-components-HourlyForecast-HourlyForecast-module__title-BhsE34\"}";
        // 1772473573013
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  